import { useState, useEffect, useCallback } from "react";

/**
 * Hook to detect and track theme changes (dark/light mode)
 * @returns {Object} Object containing isDarkMode state
 */
export const useEditorTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    document.documentElement.classList.contains("dark"),
  );

  const handleThemeChange = useCallback(() => {
    const darkModeEnabled = document.documentElement.classList.contains("dark");
    setIsDarkMode(darkModeEnabled);
  }, []);

  useEffect(() => {
    // Set up a MutationObserver to detect theme changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          handleThemeChange();
        }
      });
    });

    // Observe changes to the document element's class attribute
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Initial check
    handleThemeChange();

    // Cleanup
    return () => observer.disconnect();
  }, [handleThemeChange]);

  return { isDarkMode };
};
